<!--
 * @Author: Tina Huang
 * @Date: 2023-11-30 12:14:43
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-11-30 14:37:30
 * @Description: 
-->
<template>
  <div class="lib-container comments-box">
    <el-alert
      class="desc-alert"
      title="留言板"
      type="success"
      :closable="false"
      center
    ></el-alert>
    <div id="vcomments"></div>
  </div>
</template>
<script>
import Valine from "valine";
export default {
  mounted() {
    new Valine({
      el: "#vcomments",
      // other config
      appId: "wgD3lhLSAPHdLGH0gPy9Ep5n-gzGzoHsz",
      appKey: "DX5XDbJapqKFh8XT5myBkrcc",
      avatar: "hide",
      path: "widvere-vcomments",
      visitor: true,
    });
  },
};
</script>
<style lang="less" scoped>
.lib-container {
  padding: 5vw;
  padding-top: 120px;
  // min-height: 70vh;
}
</style>
